// @flow
import React from 'react';
import { colors } from 'bench-style-constants';
import { useFormContext } from 'react-hook-form';
import { SidebarSection, Text, SelectHookForm } from 'bench-internal-theme';
// $FlowFixMe - typescript file
import { dayOptions, monthOptions, yearOptions } from '../addon-sidebar/formOptions';
import type { LedgerAccount } from '../types';
import { FormGroup, DateFormGroup } from '../FormGroups';

type FunctionalDatesSidebarSectionProps = {
  isSubmitting: boolean,
  ledgerAccount: ?LedgerAccount,
};

const FunctionalDatesSidebarSection = ({
  ledgerAccount,
  isSubmitting,
}: FunctionalDatesSidebarSectionProps) => {
  const { watch } = useFormContext();
  const dateInactiveMonth = watch('dateInactiveMonth', undefined);
  const dateInactiveYear = watch('dateInactiveYear', undefined);

  const currentMonth = `0${new Date().getMonth() + 1}`.slice(-2).toString();
  const currentYear = new Date().getFullYear().toString();

  const isEditing = ledgerAccount?.id;

  return (
    <SidebarSection background={colors.shell}>
      <FormGroup>
        <Text color={colors.cloud} styleType="small" uppercase>
          Statement Day
        </Text>
        <SelectHookForm
          aria-label="Statement Day Of Month"
          name="statementDayOfMonth"
          isDisabled={isSubmitting}
          defaultValue={ledgerAccount?.statementDayOfMonth || 1}
          options={dayOptions}
          rules={{
            required: { value: true, message: 'Statement day is required' },
          }}
        />
      </FormGroup>
      <DateFormGroup>
        <Text color={colors.cloud} styleType="small" uppercase>
          Date Active
        </Text>
        <SelectHookForm
          aria-label="Date Active Month"
          name="dateActiveMonth"
          isDisabled={isSubmitting}
          defaultValue={
            // $FlowFixMe - Flow does not yet support method or property calls in optional chains.
            isEditing ? ledgerAccount?.accountSettings?.dateActive?.substring(5) : currentMonth
          }
          options={monthOptions}
          rules={{
            required: { value: true, message: 'Required field' },
          }}
        />
        <SelectHookForm
          aria-label="Date Active Year"
          name="dateActiveYear"
          isDisabled={isSubmitting}
          defaultValue={
            // $FlowFixMe - Flow does not yet support method or property calls in optional chains.
            isEditing ? ledgerAccount?.accountSettings?.dateActive?.substring(4, 0) : currentYear
          }
          rules={{ required: { value: true, message: 'Required field' } }}
          options={yearOptions}
        />
        <Text color={colors.cloud} styleType="small" uppercase>
          Date Inactive
        </Text>
        <SelectHookForm
          aria-label="Date Inactive Month"
          name="dateInactiveMonth"
          isDisabled={isSubmitting}
          isClearable
          // $FlowFixMe - Flow does not yet support method or property calls in optional chains.
          defaultValue={ledgerAccount?.accountSettings?.dateInactive?.substring(5)}
          options={monthOptions}
          rules={{
            // invalid to provide inactive year but not inactive month
            validate: value => (!value && dateInactiveYear?.value ? '' : true),
          }}
        />
        <SelectHookForm
          aria-label="Date Inactive Year"
          name="dateInactiveYear"
          isClearable
          isDisabled={isSubmitting}
          // $FlowFixMe - Flow does not yet support method or property calls in optional chains.
          defaultValue={ledgerAccount?.accountSettings?.dateInactive?.substring(4, 0)}
          options={yearOptions}
          rules={{
            // invalid to provide inactive month but not inactive year
            validate: value => (!value && dateInactiveMonth?.value ? '' : true),
          }}
        />
      </DateFormGroup>
    </SidebarSection>
  );
};

export default FunctionalDatesSidebarSection;
